
export const api_url = `https://app-api.testledger.dev`;
export const site_name  = `Test Ledger`;
export const stripe_key = `pk_live_51Ia3pCJA02tZ8cDtyer5G6eYZIyDjVKlg4V1LxmKkeVY6U9bn8ud1UWG12d6UdmSenia0eLuN7R0VzbVtUYzylgc00meieo56I`;

